import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { CollectionUploadedTransactions } from "../../../../components/DirectDeposit/Transactions/CollectionUploaded";

export interface ICollectionUploadedTransacitonsPage { }

export const CollectionUploadedTransactionsPage: FC<ICollectionUploadedTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Collection Uploaded"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<CollectionUploadedTransactions />}
		/>
	);
};
